import { createContext } from "react";

export const ItemsValuesContext = createContext<any>({
    itemsValues: {},
    setItemValue: (key: string, item: any) => {},
    formikProps: {},
    getDetail: (values: any, itemsValues: any) => {}
});
